import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { GuestTrackingService } from '../guest-tracking.service'
import {
  GlobalMessageType,
  GlobalMessageService,
  TranslationService,
} from '@spartacus/core'
import { LandingPagesService } from '../../landing-pages/landing-pages.service'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
@Component({
  standalone: false,
  selector: 'vs-order-tracking-guest',
  templateUrl: './order-tracking-guest.component.html',
  styleUrls: ['./order-tracking-guest.component.scss'],
})
export class OrderTrackingGuestComponent implements OnInit {
  orderData: any
  orderCheckoutForm: FormGroup
  isSubmitted: boolean = false
  firstMandateFieldError: boolean = false
  secondMandateFieldError: boolean = false
  orderIdParam: any
  displayDefaultPageMsg: boolean = false
  displaySorryPageMsg: boolean = false
  checkCondition: boolean = false
  fetchedValueFromLandingPage: any
  showLoader: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private breadCrumbService: BreadcrumbService,
    private guestTrackingService: GuestTrackingService,
    private globalMessageService: GlobalMessageService,
    private translate: TranslationService,
    private landingPagesService: LandingPagesService
  ) {}

  ngOnInit(): void {
    this.createForm()

    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('guesttrack.myOrderStatus')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    if (this.landingPagesService.floatOrderTrackingValues === undefined) {
      this.displayDefaultPageMsg = true
      this.checkTableDisplayCondition(undefined)
    }

    this.landingPagesService.floatOrderTrackingValues.subscribe((data) => {
      this.fetchedValueFromLandingPage = data
      if (this.fetchedValueFromLandingPage !== undefined) {
        let custNo = this.fetchedValueFromLandingPage['customerNumber']
        let purchaseOrderNo =
          this.fetchedValueFromLandingPage['purchaseOrderNumber']
        let referenceNo =
          this.fetchedValueFromLandingPage['orderReferenceNumber']
        if (
          custNo !== null ||
          purchaseOrderNo !== null ||
          referenceNo !== null
        ) {
          this.fetchOrderDetail(custNo, referenceNo, purchaseOrderNo)
        } else {
          this.displayDefaultPageMsg = true
          this.checkTableDisplayCondition(undefined)
        }
      }
    })
  }

  get form() {
    return this.orderCheckoutForm.controls
  }

  createForm() {
    this.orderCheckoutForm = this.formBuilder.group({
      customerNumber: new FormControl(null, [Validators.required]),
      purchaseOrderNo: new FormControl(
        null,
        Validators.pattern('^[a-zA-Z0-9- ]+$')
      ),
      referenceNumber: new FormControl(null),
    })

    this.orderCheckoutForm.controls['customerNumber'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationCustomerNumber()
        }
      }
    )
    this.orderCheckoutForm.controls['purchaseOrderNo'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationPORefNumber()
        }
      }
    )
    this.orderCheckoutForm.controls['referenceNumber'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationPORefNumber()
        }
      }
    )
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  checkValidationCustomerNumber() {
    if (
      this.orderCheckoutForm.get('customerNumber').value !== null &&
      this.orderCheckoutForm.get('customerNumber').value.trim().length > 0
    ) {
      this.firstMandateFieldError = false
    } else {
      this.firstMandateFieldError = true
    }
  }
  checkValidationPORefNumber() {
    if (
      (this.orderCheckoutForm.get('purchaseOrderNo').value !== null &&
        this.orderCheckoutForm.get('purchaseOrderNo').value.trim().length >
          0) ||
      (this.orderCheckoutForm.get('referenceNumber').value !== null &&
        this.orderCheckoutForm.get('referenceNumber').value.trim().length > 0)
    ) {
      this.secondMandateFieldError = false
    } else {
      this.secondMandateFieldError = true
    }
  }

  submitTrackStatus() {
    this.isSubmitted = true
    this.checkValidationCustomerNumber()
    this.checkValidationPORefNumber()
    if (
      !this.firstMandateFieldError &&
      !this.secondMandateFieldError &&
      this.orderCheckoutForm.valid
    ) {
      let custNo = this.orderCheckoutForm.get('customerNumber').value
      let poNo = this.orderCheckoutForm.get('purchaseOrderNo').value
      let orderNo = this.orderCheckoutForm.get('referenceNumber').value
      //  this.fetchOrderDetail(custNo, orderNo, poNo);
      if (custNo !== null || poNo !== null || orderNo !== null) {
        this.fetchOrderDetail(custNo, orderNo, poNo)
      } else {
        this.displayDefaultPageMsg = true
        this.checkTableDisplayCondition(undefined)
      }
    }
  }

  clearForm() {
    this.orderCheckoutForm.reset()

    this.isSubmitted = false
    this.secondMandateFieldError = false
  }

  fetchOrderDetail(custNo, orderNo, poNo) {
    this.showLoader = true

    this.guestTrackingService
      .fetchOrderInformation(custNo, orderNo, poNo)
      .subscribe(
        (data) => {
          if (data !== undefined && data !== null) {
            this.clearForm()
            this.orderData = data['ordersList']
            this.displayDefaultPageMsg = false
            this.checkCondition = this.checkTableDisplayCondition(
              this.orderData
            )
            this.showLoader = false
          } else {
            this.showLoader = false
            this.displayError()
          }
        },
        (error) => {
          this.showLoader = false
          this.displayError()
          // this.displayDefaultPageMsg = true;
        }
      )
  }

  displayError() {
    this.globalMessageService.add(
      { key: 'guesttrack.issueWhileFetchingOrder' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  checkTableDisplayCondition(orderData) {
    if (!this.displayDefaultPageMsg) {
      //if there is route param in URL
      if (orderData !== undefined && orderData.length > 0) {
        return true
        //DISPLAY TABLE WITH RECORD
      } else if (orderData !== undefined && orderData.length === 0) {
        this.displaySorryPageMsg = true
        return false
        //DISPLAY  - SORRY WE COULDNT FIND ANY RESULTS FOR YOUR SEARCH
      }
      this.displayError()
      return false // when there is some issue with http response
    } else {
      //DISPLAY DEFAULT - TRACK YOUR ORDER STATUS
      return false
    }
  }

  ngOnDestroy() {
    this.landingPagesService.floatOrderTrackingValues.next({
      customerNumber: null,
      purchaseOrderNumber: null,
      orderReferenceNumber: null,
    })
    this.fetchedValueFromLandingPage = ''
  }
}
